import { useMutation } from 'react-query';
import { projectService } from 'ogp/services';
import { OgpProjectDuplicatePayload } from 'ogp/services/project-service.types';
import { useInvalidateQuery } from 'shared/hooks/query-hooks/useInvalidateQuery';
import { QUERY_KEYS } from 'api/query-keys';

export const useDuplicateProject = () => {
  const mutationFn = async (project: OgpProjectDuplicatePayload) =>
    await projectService.duplicateProject(project);
  const invalidateQuery = useInvalidateQuery();
  return useMutation(mutationFn, {
    onSuccess: () => {
      invalidateQuery(QUERY_KEYS.projects());
    },
  });
};
